import { useEffect, useRef } from 'react';

import { getApplicableL2CompanyModules } from 'Deer/components/navigation/secondary/Company/CompanyModules';
import { OneOnOneDataExports } from 'Deer/intent/OneOnOne/OneOnOneDataExports';
import { OneOnOneIntentDropdown } from 'Deer/intent/OneOnOne/components/OneOnOneIntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { setSelectedView } from 'reducers/viewsSlice';

import { sendPageViewEvent } from 'constants/mixpanelHelper';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cohort: any;
}

const CompanyOneOnOneDataExportsIntent = ({ cohort }: Props) => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const { moduleName } = useOrganisationSettings();
  const applicableL2CompanyModules = getApplicableL2CompanyModules(moduleName) ?? [];

  useEffect(() => {
    dispatch(setSelectedView({ ...cohort }));
    return () => {
      dispatch(setSelectedView({}));
    };
  }, [cohort]);

  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        page: 'Company-1:1s-data-exports',
      },
    });
  }, []);

  return (
    <Layout
      Filters={
        <OneOnOneIntentDropdown
          gridRef={gridRef}
          breadcrumbs={{
            items: [
              {
                label: 'Company',
                to: applicableL2CompanyModules[0]?.value,
              },
            ],
            page: {
              label: '1:1s',
              to: '',
            },
          }}
        />
      }
    >
      <OneOnOneDataExports gridRef={gridRef} gridStatePersistenceKey="companyOneOnOneDataExports" />
    </Layout>
  );
};

export default CompanyOneOnOneDataExportsIntent;
